import React from 'react';
import { Typography } from '@fiverr-private/typography';
import { SelectorTypographyColorsType } from '@fiverr-private/theme/dist/esm/src/components/Box/types';
import { BriefSection } from '../../../types';

export interface SectionTitleProps {
  title: string;
  isEditing?: boolean;
  addColon?: boolean;
  color?: SelectorTypographyColorsType;
}

export interface CustomSectionTitleComponentProps extends SectionTitleProps {
  section?: BriefSection;
}

export const SectionTitle = ({ title, isEditing, addColon, color }: SectionTitleProps) => (
  <Typography fontWeight="bold" size="b_md" style={{ whiteSpace: 'pre-line' }} {...(color && { color })}>
    {title}
    {addColon && !isEditing ? ':' : ''}
  </Typography>
);
